import {
  Question,
  Survey,
  SurveyAudienceBody,
  SurveyVariable,
} from '../../../types/domainModels';

import QuestionnaireDownload from 'components/common/QuestionnaireDownload';

import { Overview } from './Overview/Overview';
import { SurveyLinks } from './SurveyLinks/SurveyLinks';
import { Quotas } from './Quotas/Quotas';
import { Targets } from './Targets/Targets';
import { HiddenVariables } from './HiddenVariables/HiddenVariables';

export const ReviewSurveySummary = ({
  audienceTargets,
  questions,
  survey,
  surveyVariables,
}: {
  audienceTargets: SurveyAudienceBody[];
  questions: Question[];
  survey: Survey;
  surveyVariables: SurveyVariable[];
}): JSX.Element => {
  return (
    <div className="space-y-4 text-sm">
      <Overview questions={questions} survey={survey} />
      <hr className="text-light-grey" />
      <div className="space-y-4">
        <h2 className="text-base font-semibold">Questionnaire</h2>
        <QuestionnaireDownload survey={survey} />
      </div>
      <hr className="text-light-grey" />
      <SurveyLinks survey={survey} />
      <hr className="text-light-grey" />
      <Targets audienceTargets={audienceTargets} survey={survey} />
      <hr className="text-light-grey" />
      <Quotas questions={questions} survey={survey} />
      <hr className="text-light-grey" />
      <HiddenVariables survey={survey} surveyVariables={surveyVariables} />
    </div>
  );
};
